import { useTranslation } from 'react-i18next';
import { type ActionMethods, type UserSelfPageData } from '..';
import PageTitle from '../PageTitle';
import ActiveSessionsContent from './ActiveSessionsContent';
import useSessionsData from './useSessionsData';

const useActiveSessionsPageData = (actions: ActionMethods) => {
    const { t } = useTranslation('userSelf');
    const { sessionsData, revokeSession } = useSessionsData();

    if (!sessionsData) {
        return null;
    }

    const page: UserSelfPageData = {
        type: 'activeSessions',
        title: <PageTitle title={t('userSelf:sessions.title')} />,
        body: <ActiveSessionsContent data={sessionsData} revoke={revokeSession} />,
        onMenuItemClicked: actions.goToActiveSessions,
        onCloseOrBackClicked: actions.goBackToViewProfile,
    };

    return page;
};

export default useActiveSessionsPageData;
